export const SOCIAL_CHANNEL_HEADER = 'X-OpenReferences-Channel';
export const SOCIAL_CHANNEL_VALUE = 'social';

export function withSocialChannelHeaders(
  headers: Record<string, string>,
  isSocialMode: boolean,
): Record<string, string> {
  if (!isSocialMode) {
    return headers;
  }

  return {
    ...headers,
    [SOCIAL_CHANNEL_HEADER]: SOCIAL_CHANNEL_VALUE,
  };
}
